import { render, staticRenderFns } from "./store-checkout.vue?vue&type=template&id=2f754e18&scoped=true"
import script from "./store-checkout.vue?vue&type=script&lang=js"
export * from "./store-checkout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f754e18",
  null
  
)

export default component.exports